export default __webpack_public_path__ + "static/media/05-VEH-(3-2).0136dd5c.jpg";